<template>
    <div class="StrongFamiliesLayout" style="min-height:100vh" ref="content" v-if="UserPrivateProfile.UserId">

        <div style="touch-action:none;">
            <div class="navbar navbar-light navbar-expand-md navigation-clean" style="z-index:2;display:inline-flex; width:100vw;">
                <div v-if="IsMobile">
                    <font-awesome-icon :icon="['fa', 'bars']" @click="CloseSlideout()" />
                </div>
                <font-awesome-icon v-if="!IsMobile" :icon="['fa', 'bars']" id="HamburgerMenuDesktop" @click="HamburgerMenuDesktop()" class="pointer" />
                <a id="navbar-brand" class="navbar-brand pointer"><router-link to="/"><img v-bind:src="SiteLogoFull" /></router-link></a>

            </div>
        </div>
        <div>
            <b-row no-gutters>
                <b-col cols="2" :class="IsMobile ? 'sidebar' : 'sidebarColumn paper side-tabs'" :style="[IsMobile ? sidebarStyle : {'max-width': 'max-content', 'white-space':'nowrap', 'height':'fit-content','display' : 'block'}]" ref="sidebarColumn">
                    <div :class="IsMobile? 'slideout-menu sidebarColumn' : 'sidebar'" style="slideout-left-menu">
                        <Slideout  @hook:mounted="$refs.Slideout.slideout.disableTouch()" v-if="IsMobile" menu="#menu" panel="#panel" :padding="innerWidth * 0.7" ref="Slideout" @on-open="sidebarStyle = {'max-width': 'max-content', 'white-space':'nowrap', 'height':'fit-content'}" @on-close="sidebarStyle = {'display':'none'}" @on-translatestart="sidebarStyle = {'max-width': 'max-content', 'white-space':'nowrap', 'height':'fit-content'}" />
                        <div :class="IsMobile ? 'mobile-name-style' : 'display-none'">
                            <div> {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</div>
                        </div>
                        <b-nav :id="IsMobile ? 'menu' : 'desktop'" tabs vertical>

                            <span v-for="(item, index) in SideBarItems" class="MobileActiveStyle">
                                <!--Does not have a drop down-->
                                <b-nav-item @click="CloseSlideout()" v-if="Object.keys(item.DropDownList).length < 1 && CheckPermission(item.Permission) " v-on:click="ChangePaneShown(item.Name)" v-bind:class="{ active: PanesShown == item.Name }"><font-awesome-icon :icon="[item.IconPrefix, item.Icon]" /> {{item.Label}}</b-nav-item>
                                <!--Has Dropdown-->
                                <b-nav-item v-if="Object.keys(item.DropDownList).length > 0 && CheckPermission(item.Permission)" v-b-toggle="item.Name"><font-awesome-icon :icon="[item.IconPrefix, item.Icon]" /> {{item.Label}}</b-nav-item>
                                <b-collapse v-if="Object.keys(item.DropDownList).length > 0" :id="item.Name" :accordion="item.Name" role="tabpanel">
                                    <b-card no-body v-for="dropdownItem in item.DropDownList">
                                        <b-nav-item @click="CloseSlideout()" v-if="CheckPermission(dropdownItem.Permission) && dropdownItem.Name != 'Record'" v-on:click="ChangePaneShown(dropdownItem.Name)" v-bind:class="{ active: PanesShown == dropdownItem.Name }">
                                            <font-awesome-icon :icon="[dropdownItem.PrefixIcon, dropdownItem.Icon]" /> {{dropdownItem.Label}}
                                        </b-nav-item>
                                        <div v-if="dropdownItem.hasOwnProperty('Record') && Object.keys(dropdownItem.Record).length > 0 ">
                                            <b-nav-item @click="CloseSlideout()" v-for="r in dropdownItem.Record " v-bind:class="{ active: PanesShown == r.Id }">

                                                <span v-on:click="ChangePaneShown(r.Id)">

                                                    <font-awesome-icon :icon="[dropdownItem.IconPrefix, dropdownItem.Icon]" />
                                                    {{DisplayLabel(r,dropdownItem.Label)}}
                                                </span>
                                                <span style="float:right;" v-on:click="CloseRecord(dropdownItem.RemoveRecordPath,dropdownItem.ChangePaneNameAfterRecordRemoval, r.Id)">X</span>
                                            </b-nav-item>
                                        </div>
                                    </b-card>
                                </b-collapse>
                            </span>
                            <b-nav-item><Logout /></b-nav-item>
                        </b-nav>
                    </div>
                </b-col>
                <b-col id="panel" style="height:90vh;">
                    <div :style="[!IsMobile ? null : slideoutOpen() ? {'position': 'fixed', 'padding-right':'100%', 'top':'0','bottom':'0', 'z-index': '1'} : {'position': 'fixed', 'padding-right':'3vw', 'top':'0','bottom':'0', 'z-index': '1'}]"></div>
                    <div>
                        <div v-for="item in SideBarItems">
                            <div v-if="Object.keys(item.DropDownList).length < 1" v-show="PanesShown == item.Name && CheckPermission(item.Permission)" :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                <component :is="item.Name"></component>
                            </div>
                            <div v-else v-for="dropDownItem in item.DropDownList">
                                <div v-if="dropDownItem.hasOwnProperty('VIf')">
                                    <div v-if="PanesShown == dropDownItem.Name && CheckPermission(dropDownItem.Permission)" :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                        <component :is="dropDownItem.Name"></component>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-show="PanesShown == dropDownItem.Name" v-if="CheckPermission(dropDownItem.Permission)" :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                        <component :is="dropDownItem.Name"></component>
                                    </div>
                                </div>
                                <div v-if="dropDownItem.Name == 'Record'">
                                    <div v-for="(r,Id) in dropDownItem.Record" v-if="r.hasOwnProperty(dropDownItem.HasOwnProperty)" v-show="PanesShown == Id">
                                        <div :class="IsMobile ? 'paper' : 'paper content'" :style="[IsMobile ? {'margin':'0px !important'} : null]">
                                            <component :is="dropDownItem.ComponentName" v-bind:[dropDownItem.DataToPass]="r" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <!--Logged in User-->
        <p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>
        <SessionTimeout :timeout-seconds="1200" />
    </div>


</template>

<script>
    //import services
    import $ from 'jquery'
    import { isMobile } from 'mobile-device-detect';


    import Home from "./Home.vue";

    import ChurchList from '../Volunteers/Churches/ChurchList.vue';
    import ChurchRecord from "../Volunteers/Churches/ChurchRecord/ChurchRecord.vue";

    import VolunteerFamilyList from '../Volunteers/VolunteerFamilies/VolunteerFamilyList.vue';
    import VolunteerFamilyRecord from '../Volunteers/VolunteerFamilies/VolunteerFamilyRecord/VolunteerFamilyRecord.vue';

    import CommunityFamilyList from '../Community/CommunityFamilies/CommunityFamilyList.vue';
    import CommunityFamilyRecord from '../Community/CommunityFamilies/CommunityFamilyRecord/CommunityFamilyRecord.vue';
    import ReferralRecord from '../Community/Referrals/ReferralRecord/ReferralRecord.vue';

    import ReferralList from '../Community/Referrals/ReferralList.vue';

    import DocumentsPane from '../../Core/RecordComponents/DocumentsPane.vue';
    import UserDrafts from '../../Core/RecordComponents/UserDrafts.vue';
    import SignaturesPane from '../../Core/RecordComponents/SignaturesPane.vue';
    import ReportsPane from '../Reports/ReportsPane.vue';

    //import components
    //import ChildList from "../Children/ChildList.vue";
    //import AddNewChild from "../Children/AddNewChild.vue";
    

    //import ProgramServiceLog from "../MiscPanes/ProgramServiceLog.vue";

    //APPOINTMENTS


    //FLEX FUNDS
    

    
    import Slideout from 'vue-slideout'
    
    //import DirectorEmployeeView from "../../Admin/DirectorEmployeeView.vue";
    //import SubProgramSettings from '../../Core/SubProgramSettings/SubProgramSettingsPane.vue';
    import Logout from '../../Core/UI/Logout.vue';
    //import UsersettingsPane from '../Usersettings/UsersettingsPane.vue';
    import SessionTimeout from '../../Core/UI/SessionTimeout.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    import { faUsers } from '@fortawesome/free-solid-svg-icons';
    library.add(faUsers);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileAlt);
    import { faToolbox } from '@fortawesome/free-solid-svg-icons';
    library.add(faToolbox);
    import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faAngleDoubleLeft);
    import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faAngleDoubleRight);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);
    import { faSignature } from '@fortawesome/free-solid-svg-icons';
    library.add(faSignature);
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faCalendarAlt);
    import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
    library.add(faDollarSign);
    import { faBook } from '@fortawesome/free-solid-svg-icons';
    library.add(faBook);
    import { faCog } from '@fortawesome/free-solid-svg-icons';
    library.add(faCog);
    import { faStar } from '@fortawesome/free-solid-svg-icons';
    library.add(faStar);
    import { faChurch } from '@fortawesome/free-solid-svg-icons';
    library.add(faChurch);
    import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons';
    library.add(faPeopleGroup);
    import { faPeopleRoof } from '@fortawesome/free-solid-svg-icons';
    library.add(faPeopleRoof);
    import { faCity } from '@fortawesome/free-solid-svg-icons';
    library.add(faCity);
    import { faTowerCell } from '@fortawesome/free-solid-svg-icons';
    library.add(faTowerCell);
    import _ from 'lodash';
    import { EventBus } from '../../../services/event-bus.js';
    export default {
        name: "StrongFamiliesLayout",
        created() {
            this.$store.commit("User.PrivateProfile.Clear");
            let vm = this;
            EventBus.$on('documents-requiring-my-signature-updated', docCount => {
                vm.DocumentsRequiringMySignature = docCount;
            });

            EventBus.$on('globalpanechange', paneName => {
                console.log("from layout the globalpanechange was initiated");
                vm.PanesShown = paneName
            });

        },
        beforeDestroy() {
            EventBus.$off('documents-requiring-my-signature-updated');
            EventBus.$off('globalpanechange');
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_OLIVER.png",
                sidebarStyle: { 'display': 'none' },
                innerWidth: window.innerWidth,
                SidebarWidth: 0,
                DocumentsRequiringMySignature: 0,
                PanesShown: "Home",
            };
        },
        methods: {
            CloseSlideout() {
                if (this.$refs.Slideout) {
                    this.$refs.Slideout.slideout.toggle();
                }
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            ChangePaneShown(paneName) {
                this.PanesShown = paneName;
                this.$nextTick(function () {
                    EventBus.$emit('profile-update-needed', paneName);
                })

            },
            GetEmployeePrivateProfile() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Users/UserPrivateProfile", {}, this.GetEmployeePrivateProfileSuccess, () => { }, true);
            },
            GetEmployeePrivateProfileSuccess(response) {
                this.$store.commit("User.PrivateProfile.Replace", response.data.data);
            },
            CloseRecord: function (path, paneName, Id) {
                if (this.PanesShown == Id) {
                    this.ChangePaneShown(paneName);
                }
                this.$store.commit(path, Id);
                this.$nextTick(function () {
                    EventBus.$emit('profile-update-needed', this.PanesShown);
                });
                
            },
            DocumentsRequiringMySignatureComp: function () {
                if (this.DocumentsRequiringMySignature != 0) {
                    return this.DocumentsRequiringMySignature
                } else {
                    return "";
                }
            },
            DisplayLabel(obj, path) {
                return _.get(obj, path);
            },
            slideoutOpen() {
                if (this.$refs.Slideout) {
                    return this.$refs.Slideout.slideout.isOpen();
                }
            },
            HamburgerMenuDesktop() {
                if (this.$refs.sidebarColumn.style.display == 'block') {
                    this.$refs.sidebarColumn.style.display = 'none';
                }
                else {
                    this.$refs.sidebarColumn.style.display = 'block';
                }
                
            },
        },
        components: {
            Home,
            ChurchList,
            VolunteerFamilyList,
            VolunteerFamilyRecord,
            ChurchRecord,
            CommunityFamilyList,
            CommunityFamilyRecord,
            ReferralList,
            ReferralRecord,
            DocumentsPane,
            UserDrafts,
            SignaturesPane,
            ReportsPane,
            Logout,
            SessionTimeout,
            
            
            Slideout,
        },
        mounted() {
            this.GetEmployeePrivateProfile();
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            OpenChurchRecords() {
                return this.$store.state.Churches.Profiles;
            },
            OpenVolunteerFamilyRecords() {
                return this.$store.state.VolunteerFamilies.Profiles;
            },
            OpenCommunityFamilyRecords() {
                return this.$store.state.CommunityFamilies.Profiles;
            },
            OpenCommunityFamilyReferralRecords() {
                return this.$store.state.CommunityFamilyReferrals.Profiles;
            },
            OpenTeamRecords() {
                return this.$store.state.Teams.TeamProfiles;
            },
            IsMobile: function () {
                return isMobile;
            },
            SiteLogoFull: function () {
                return this.$baseURL + this.sitelogo;
            },
            SideBarItems: function () {
                let obj = {};
                //HOME
                obj["Home"] = {
                    Name: 'Home',
                    Label: 'Home',
                    IconPrefix: 'fa',
                    Icon: 'star',
                    DropDownList: [],
                    Permission: ''
                }
                //VOLUNTEERS
                obj["Volunteers"] = {
                    Name: 'Volunteers',
                    Label: 'Volunteers',
                    IconPrefix: 'fa',
                    Icon: 'users',
                    Permission: ''
                };
                obj["Volunteers"]["DropDownList"] = {};
                obj["Volunteers"]["DropDownList"]["0"] = {
                    Name: 'VolunteerFamilyList',
                    Label: 'Families',
                    IconPrefix: 'fa',
                    Icon: 'home',
                    Permission: ''
                };
                obj["Volunteers"]["DropDownList"]["1"] = {
                    Name: 'ChurchList',
                    Label: 'Churches',
                    IconPrefix: 'fa',
                    Icon: 'church',
                    Permission: ''
                };
                obj["Volunteers"]["DropDownList"]["Record"] = {
                    Name: "Record",
                    Record: this.OpenChurchRecords,
                    IconPrefix: '',
                    Icon: '',
                    HasOwnProperty: 'SubProgramMemberships',
                    Label: 'Name',
                    ComponentName: "ChurchRecord",
                    DataToPass: "list-data",
                    RemoveRecordPath: "Churches.Profiles.Remove",
                    ChangePaneNameAfterRecordRemoval: "ChurchList",
                    Permission: ''
                },
                obj["Volunteers"]["DropDownList"]["Record2"] = {
                    Name: "Record",
                    Record: this.OpenVolunteerFamilyRecords,
                    IconPrefix: '',
                    Icon: '',
                    HasOwnProperty: 'Id',
                    Label: 'Name',
                    ComponentName: "VolunteerFamilyRecord",
                    DataToPass: "list-data",
                    RemoveRecordPath: "VolunteerFamilies.Profiles.Remove",
                    ChangePaneNameAfterRecordRemoval: "VolunteerFamilyList",
                    Permission: ''
                },
                //COMMUNITY
                obj["Community"] = {
                    Name: 'Community',
                    Label: 'Community',
                    IconPrefix: 'fa',
                    Icon: 'city',
                    Permission: ''
                };
                obj["Community"]["DropDownList"] = {};
                obj["Community"]["DropDownList"]["0"] = {
                    Name: 'ReferralList',
                    Label: 'Unlinked',
                    IconPrefix: 'fa',
                    Icon: 'link-slash',
                    Permission: ''
                };
                obj["Community"]["DropDownList"]["1"] = {
                    Name: 'CommunityFamilyList',
                    Label: 'Families',
                    IconPrefix: 'fa',
                    Icon: 'people-group',
                    Permission: ''
                };
                obj["Community"]["DropDownList"]["Record"] = {
                    Name: "Record",
                    Record: this.OpenCommunityFamilyRecords,
                    IconPrefix: 'fa',
                    Icon: 'people-group',
                    HasOwnProperty: 'Id',
                    Label: 'Name',
                    ComponentName: "CommunityFamilyRecord",
                    DataToPass: "list-data",
                    RemoveRecordPath: "CommunityFamilies.Profiles.Remove",
                    ChangePaneNameAfterRecordRemoval: "CommunityFamilyList",
                    Permission: ''
                }
                obj["Community"]["DropDownList"]["Record2"] = {
                    Name: "Record",
                    Record: this.OpenCommunityFamilyReferralRecords,
                    IconPrefix: 'fa',
                    Icon: 'link-slash',
                    HasOwnProperty: 'Id',
                    Label: 'Name',
                    ComponentName: "ReferralRecord",
                    DataToPass: "list-data",
                    RemoveRecordPath: "CommunityFamilyReferrals.Profiles.Remove",
                    ChangePaneNameAfterRecordRemoval: "ReferralList",
                    Permission: ''
                },
                //DOCUMENTS
                obj["Documents"] = {
                    Name: 'Documents',
                    Label: 'Documents',
                    IconPrefix: 'fa',
                    Icon: 'file-alt',
                    Permission: ''
                };
                obj["Documents"]["DropDownList"] = {};
                obj["Documents"]["DropDownList"]["0"] = {
                    Name: 'UserDrafts',
                    Label: 'Drafts',
                    IconPrefix: 'fa',
                    Icon: 'edit',
                    Permission: 'Navigation_Drafts'
                };
                obj["Documents"]["DropDownList"]["1"] = {
                    Name: 'SignaturesPane',
                    Label: 'Signatures',
                    IconPrefix: 'fa',
                    Icon: 'signature',
                    Permission: 'Navigation_Signatures'
                };
                //Reports
                obj["Reports"] = {
                    Name: 'ReportsPane',
                    Label: 'Reports',
                    IconPrefix: 'fa',
                    Icon: 'chart-bar',
                    DropDownList: []
                };
                //obj["Log"] = {
                //    Name: 'ProgramServiceLog',
                //    Label: 'Log',
                //    IconPrefix: 'fas',
                //    Icon: 'book',
                //    DropDownList: [],
                //    Permission: 'Wraparound.ProgramServiceLog'
                //};
                //obj["DirectorEmployeeView"] = {
                //    Name: 'DirectorEmployeeView',
                //    Label: 'Employees',
                //    IconPrefix: 'fa',
                //    Icon: 'users',
                //    DropDownList: [],
                //    Permission: 'Navigation_Employees'
                //};
                //obj["SubProgramSettings"] = {
                //    Name: 'SubProgramSettings',
                //    Label: 'Program',
                //    IconPrefix: 'fa',
                //    Icon: 'cog',
                //    DropDownList: [],
                //    Permission: 'SubProgram.Settings.Edit'
                //};
                return obj;
            }
        },
    }
</script>

<style scoped>
    .upper-right {
        position: absolute;
        top: 0;
        right: 40px;
        z-index: 2;
    }

    .ExpandButtons {
        width: 100%;
        height: 100%;
        /*margin-top:1rem;*/
        color: black;
        padding-bottom: 1rem;
    }

    .content {
        position: absolute;
        width: 98%; /*stop page scroll*/
        min-height: 100%;
    }

    .sidebarSmallButtons > * {
        padding: 0;
        text-align: center;
    }
    /*li.active a {
        color: white;
    }*/
    .slideout-menu {
        top: 0;
        bottom: 0;
        width: 75vw;
        height: 100vh;
        overflow-y: scroll;
        /*-webkit-overflow-scrolling: touch;*/
        z-index: 1;
        display: none;
        background-color: white;
        /*background-color: #1D1F20;
    color: white;*/
    }

    .slideout-menu-left {
        left: 0;
    }

    .slideout-menu-right {
        right: 0;
    }

    .slideout-panel {
        /*background-color: #4B5;
    color: white;*/
        touch-action: pan-y;
        position: relative;
        z-index: 1;
        /*will-change: transform;*/
    }

    .slideout-open,
    .slideout-open body,
    .slideout-open .slideout-panel {
        position: fixed;
        overflow: hidden;
    }

        .slideout-open .slideout-menu {
            display: block;
        }

    .mobile-name-style {
        height: 64px;
        border-bottom-color: black;
        border-bottom-width: thin;
        border-bottom: double;
        justify-content: center;
        font-size: x-large;
        font-weight: bold;
        display: flex;
        align-items: center;
    }

    .display-none {
        display: none;
    }

    .slideout-left-menu {
        height: 100%;
        width: 60vw;
        background-color: white;
    }
    @media screen and (max-width: 990px){
     /* CSS that should be displayed if width is equal to or less than 991px goes here */
     #navbar-brand{
         position:relative;
         right:1rem;
         margin-left:auto;
     }
     #HamburgerMenuDesktop{
         display:block;
     }

    }
    @media screen and (min-width: 991px){
     /* CSS that should be displayed if width is equal to or less than 991px goes here */
        #navbar-brand{
            position:relative;
        }
        #HamburgerMenuDesktop{
            display:none;
        }
        #sideBarID{
            display:block !important;
        }
    }

    .StrongFamiliesLayout {
        background-color: #605271;
    }
</style>